// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  background-color: #fff;
  color: #000;
  font-family: 'Verdana', 'Arial', 'sans-serif';
  font-size: 12px;
  overflow: -moz-scrollbars-vertical;
  position: relative;
  width: 100%;
  height: auto !important;
}

h2 {
  color: black;
  font-size: 44px;
  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';
}

.bold {
  font-weight: bold;
}

.whitebg {
  background-color: #fff;
}
.italic {
  font-style: italic;
}

.underline {
  text-decoration: underline;
}

.red {
  color: red;
}

.timezone-stamp {
  font-size: 0.8em;
}

.adminoverlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  background: black;
  color: white;
  opacity: 0.25;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 998;
}

a[disabled],
a[disabled]:hover {
  pointer-events: none;
  cursor: not-allowed;
}
/* color backgrounds of non-production environments to avoid confusion */
.lmgr-dev {
  background-color: #fdd;
  background: linear-gradient(#fdd, #fff 10%, #fff 90%, #fdd) no-repeat fixed;
}
.lmgr-qa {
  background-color: #dfd;
  background: linear-gradient(#dfd, #fff 10%, #fff 90%, #dfd) no-repeat fixed;
}
.lmgr-uat {
  background-color: #ddf;
  background: linear-gradient(#ddf, #fff 10%, #fff 90%, #ddf) no-repeat fixed;
}
.not-production {
  background-color: #ffd;
  background: linear-gradient(#ffd, #fff 10%, #fff 90%, #ffd) no-repeat fixed;
}

.ng-hide.ng-hide-animate {
  display: none !important;
}

.trainingInsightsNew {
  height: 47px;
  z-index: 10;
  position: absolute;
  left: 78%;
  top: -20%;
}

.hidden-feature {
  display: none;
}

.box-shadow {
  box-shadow:
    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/common.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;AACA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;AACA;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;AACA;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;AACA;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;mDAEiD;AACnD","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  background-color: #fff;\n  color: #000;\n  font-family: 'Verdana', 'Arial', 'sans-serif';\n  font-size: 12px;\n  overflow: -moz-scrollbars-vertical;\n  position: relative;\n  width: 100%;\n  height: auto !important;\n}\n\nh2 {\n  color: black;\n  font-size: 44px;\n  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.whitebg {\n  background-color: #fff;\n}\n.italic {\n  font-style: italic;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.red {\n  color: red;\n}\n\n.timezone-stamp {\n  font-size: 0.8em;\n}\n\n.adminoverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  background: black;\n  color: white;\n  opacity: 0.25;\n  width: 100%;\n  height: 100%;\n  display: block;\n  z-index: 998;\n}\n\na[disabled],\na[disabled]:hover {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n/* color backgrounds of non-production environments to avoid confusion */\n.lmgr-dev {\n  background-color: #fdd;\n  background: linear-gradient(#fdd, #fff 10%, #fff 90%, #fdd) no-repeat fixed;\n}\n.lmgr-qa {\n  background-color: #dfd;\n  background: linear-gradient(#dfd, #fff 10%, #fff 90%, #dfd) no-repeat fixed;\n}\n.lmgr-uat {\n  background-color: #ddf;\n  background: linear-gradient(#ddf, #fff 10%, #fff 90%, #ddf) no-repeat fixed;\n}\n.not-production {\n  background-color: #ffd;\n  background: linear-gradient(#ffd, #fff 10%, #fff 90%, #ffd) no-repeat fixed;\n}\n\n.ng-hide.ng-hide-animate {\n  display: none !important;\n}\n\n.trainingInsightsNew {\n  height: 47px;\n  z-index: 10;\n  position: absolute;\n  left: 78%;\n  top: -20%;\n}\n\n.hidden-feature {\n  display: none;\n}\n\n.box-shadow {\n  box-shadow:\n    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,\n    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
